var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isEmpty } from 'lodash';
import { typedLocalStorage } from '../utils/typedLocalStorage';
import { addCustomFieldsInFormData } from './modals.ts';
const handleResponse = (response) => __awaiter(void 0, void 0, void 0, function* () {
    if (!response.ok) {
        const error = yield response.text();
        throw new Error(error);
    }
    return response.json();
});
export const initApi = (clientId) => {
    const clientUrl = new URL(location.href).searchParams.get('clientUrl');
    const modifiedInit = {
        headers: {
            'client-id': String(clientId),
            Referer: clientUrl,
        },
    };
    return {
        getArticlesList: () => __awaiter(void 0, void 0, void 0, function* () {
            const response = yield fetch(`/widget/instruction`, modifiedInit);
            return handleResponse(response);
        }),
        getArticle: (articleId) => __awaiter(void 0, void 0, void 0, function* () {
            const response = yield fetch(`/widget/instruction/${articleId}`, modifiedInit);
            return handleResponse(response);
        }),
        findArticles: (searchText) => __awaiter(void 0, void 0, void 0, function* () {
            const response = yield fetch(`/widget/instruction?text=${encodeURIComponent(searchText)}`, modifiedInit);
            return handleResponse(response);
        }),
        createIssue: (issueData) => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            const formData = new FormData();
            formData.append('name', issueData.name);
            formData.append('email', issueData.email);
            formData.append('description', issueData.description);
            formData.append('g_recaptcha_response', issueData.g_recaptcha_response);
            formData.append('clientId', String(clientId));
            formData.append('title', `${issueData.name} / Web Widget / ${new Date().toLocaleString()}`);
            const referrerFromWindow = typedLocalStorage.getItem('refererHost') || 'not recognized';
            formData.append('referer', `${referrerFromWindow}`);
            (_a = issueData.files) === null || _a === void 0 ? void 0 : _a.forEach((file, index) => formData.append(`files[${index}]`, file));
            !isEmpty(issueData.custom_fields) && addCustomFieldsInFormData(formData, issueData);
            const response = yield fetch(`/issue/create`, {
                method: 'POST',
                body: formData,
                headers: Object.assign({}, modifiedInit.headers),
            });
            return handleResponse(response);
        }),
        getChatMessages: (paramData) => __awaiter(void 0, void 0, void 0, function* () {
            const clientUrl = new URL(location.href).searchParams.get('clientUrl');
            const response = yield fetch(`/widget/message?${new URLSearchParams(Object.assign(Object.assign({}, paramData), { page_url: clientUrl }))}`, modifiedInit);
            return handleResponse(response);
        }),
        sendFiles: (files) => __awaiter(void 0, void 0, void 0, function* () {
            const filesData = new FormData();
            files.forEach((file, index) => filesData.append(`file[${index}]`, file));
            const response = yield fetch(`/api/file`, {
                method: 'POST',
                body: filesData,
                headers: Object.assign({}, modifiedInit.headers),
            });
            return handleResponse(response);
        }),
    };
};
